<template>
<!-- 修改生产单，现不支持 -->
  <div>
    <el-card>
      <define-input label="客户信息" v-model="productTask.customer"  style="width: 350px;margin-left:-60px"></define-input>
      <span class="defineSpan"  style="width: 350px;margin-left:40px">订单日期</span>
        <el-date-picker
      v-model="productTask.createTime"
      type="date"
      placeholder="选择日期"
      style="margin-left:12px"
      @change="getDateArray()">
    </el-date-picker>
        <!-- <define-input label="产品" v-model="productTask.product" style="width: 350px;margin-left:-30px"></define-input> -->
        <span class="defineSpan" style="margin-left:50px;">坯布名称</span>
        <el-select v-model="productTask.product" filterable placeholder="坯布名称" clearable :change="selectd(productTask.product)" style="width:200px;margin-left:12px;">
          <el-option
            v-for="item in templete"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <br>
        <define-input label="订单数量" v-model="productTask.outputQuantityTotal" style="width: 350px;margin-left:-61px"></define-input>
        <el-radio-group v-model="radio" style="margin-left:10px">
            <el-radio :label="3">米</el-radio>
            <el-radio :label="6">质量</el-radio>
         </el-radio-group>
        <br>
        <define-input label="工艺组织" v-model="productTask.processOrganization"  style="width: 350px;margin:3px 0 0 -60px"></define-input>
        <define-input label="针织密度" v-model="productTask.density" style="width: 350px;margin-left:-60px"></define-input>
        <entity-input iconfont="icon-icon_juzhentiankong" v-model="productTask.user" label="创建者"
                      :options="{search:'user'}" format="{username}" style="width: 300px;margin-left:21px">
        </entity-input><br>
        <define-input label="补充说明" v-model="productTask.supplementaryNote" style="width: 995px;margin: 3px 0 0 -60px"></define-input>
    </el-card>
    <el-card>
      <define-table :data="productTask.processSheets" :height="`${productTask.processSheets.length * 165 + 70}px`" class="table1" style="margin-left:3px"
                    :haveIndex="false" :havePage="false" >
        <define-column label="操作" v-slot="{ data }" width="78px" :fixed="true">
          <i class="iconfont iconadd" id="add" @click="AddRow(true,data)"></i>
          <i class="iconfont iconRemove" id="remove" @click="AddRow(false,data)" style="margin-left:3px"></i>
        </define-column>
        <define-column columnType="expand">
            <template v-slot="{ data }">
              <default-input label="垫纱记录" v-model="data.row.yarnNote" style="margin: -40px 0 5px 83px;width:1121px"></default-input><br>
              <default-input label="穿纱方式" v-model="data.row.threadingMethod" style="width:1121px;margin: 0 0 0 83px"></default-input>
            </template>
        </define-column>
        <define-column label="梳节" v-slot="{ data }" width="">
          <el-input v-model="data.row.combKnot" ></el-input>
        </define-column>
         <define-column label="原料规格" v-slot="{ data }" width="">
          <el-input v-model="data.row.materialFormat" placeholder="--"></el-input>
        </define-column>
        <define-column label="原料批号" v-slot="{ data }" width="">
          <el-input v-model="data.row.materialsBatchNumber" placeholder="--"></el-input>
        </define-column>
         <define-column label="线圈长度" v-slot="{ data }" width="">
          <el-input v-model="data.row.coil" placeholder="--" style="width:70px"></el-input><i class="ii" style="font-style:normal;">mm/腊克</i>
        </define-column>
        <define-column label="头纹" v-slot="{ data }" width="">
          <el-input v-model="data.row.hairline" placeholder="--" style="width:110px"></el-input><i class="ii" style="font-style:normal;">根</i>
        </define-column>
        <define-column label="盘头个数" v-slot="{ data }" width="">
          <el-input v-model="data.row.panHead" placeholder="--"></el-input>
        </define-column>
        <define-column label="送纱量" v-slot="{ data }" width="">
          <el-input v-model="data.row.yarnFeed" placeholder="--"></el-input>
        </define-column>
      </define-table>
      <el-input type="textarea" :rows="2" placeholder="工艺补充说明" v-model="productTask.processSheetSupplementaryNote"/>
    </el-card>
     <!--  机台选择  -->
    <el-card>
      <define-table :data="machineList" ref="multipleTable" :havePage="false" :height="`${machineList.length * 55 + 55}px`" @selection="machineSelect" :haveIndex="false" >
        <define-column columnType="selection"></define-column>
        <define-column field="number" label="编号" width="180"></define-column>
        <define-column field="workshop" label="所在车间"></define-column>
          <define-column v-slot="{data}" label="车速">
            <el-input v-model="data.row.speed" placeholder="--" style="width:90px" @input="changeOrder($event,data.row)"/>
            <i class="ii" style="font-style:normal;">转/分钟</i>
          </define-column>
          <define-column v-slot="{data}" label="落布米数">
            <el-input v-model="data.row.dropMeter" placeholder="--" style="width:120px"></el-input><i class="ii" style="font-style:normal;">M</i>
          </define-column>
        <define-column label="门幅数量" v-slot="{ data }">
          <el-input define-input v-model="data.row.doorWidth" placeholder="--"></el-input>
        </define-column>
        <define-column v-slot="{ data }" label="幅宽">
            <el-input v-model="data.row.widthCloth" placeholder="--"></el-input>
        </define-column>
        <define-column label="米数" v-slot="{ data }">
            <el-input v-model="data.row.outputQuantity" placeholder="--" style="width:120px"></el-input><i class="ii" style="font-style:normal;">M</i>
          </define-column>
      </define-table>
    </el-card>
    <div style="float:right;margin: 10px 30px 0 0">
      <el-button type="primary" @click="onSubmit()">确定</el-button>
      <el-button type="danger" @click="cancel()">取消</el-button>
    </div>
    <el-dialog
        title="选择需要删除的模板"
        :visible.sync="deleteDialog"
        width="30%">
        <define-table :data="templeteList" :havePage="false" height="auto" @selection="deleteTemple" :haveIndex="false" >
          <define-column columnType="selection"></define-column>
          <define-column label="模板编号" field="number"></define-column>
          <define-column label="创建时间" :filter="(row) => $filterTime(row.createTime)" :sort="true"></define-column>
        </define-table>
        <span slot="footer" class="dialog-footer">
          <el-button el-button @click="deleteDialog = false">取 消</el-button>
          <el-button type="primary" @click="deleteSubmit()">确 定</el-button>
        </span>
    </el-dialog>

    <el-dialog
      title="添加模板"
      :visible.sync="addDialog"
      width="30%">
      <md-input v-model="temple.number" icon="el-icon-search" name="title" placeholder="输入模板编号">
        模板编号
      </md-input>
      <span slot="footer" class="dialog-footer">
        <el-button el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="addSubmit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import * as api from '@/api/factory/product/orderList/edit'
import '@/styles/productOrder.scss'
export default {
  name: 'ProductOrderEdit',
  components: {},
  data () {
    return {
      // 单位
      radio: 3,
      outputQuantityTotal: '',
      deleteTemples: [],
      deleteDialog: false,
      addDialog: false,
      // 模板获取数据
      templeteList: [],
      // 模板选择
      templete: [],
      addTemplete: false,
      value: '',
      // 模板数据
      temple: {
        number: '',
        processSheets: [{ line: 'GB1' }]
      },
      productTask: {
        processSheets: [],
        productOrderItems: [
          { machine: { machineState: '' } }
        ]
      },
      productOrderItems: [],
      machineList: [],
      hadMachine: []
    }
  },
  methods: {
    changeOrder(e, row) {
      console.log('值发生改变', e, row)
      console.log(this.machineList)
    },
    addSubmit () {
      this.addDialog = false
      this.productTask.product = this.temple.number
    },
    // 机台选择
    machineSelect (val) {
      this.productOrderItems = val
    },
    // 工艺添加/删除行
    AddRow (state, data) {
      var list = this.productTask.processSheets
      if (state) {
        if (list.length < 4) { list.push({ line: `L${list.length + 1}` }) }
      } else {
        if (list.length > 1) {
          list.splice(data.$index, 1)
        } else {
          list.splice(data.$index, 1)
          list.push({ line: 'L1' })
        }
      }
    },

    // 获取初始生产单数据
    fetchData () {
      var params = { productId: this.$route.params.id }
      api.fetchData(params).then(res => {
        this.productTask = res.data
        this.productTask.outputQuantityTotal /= 100
        this.productTask.dropMeter /= 100
        // this.productTask.createTime = Vue.filter(this.productTask.createTime)
        // console.log(this.productTask.createTime)
        this.productTask.productOrderItems.forEach(item => {
          item.outputQuantity /= 100
          this.hadMachine.push({ id: item.machine.id, number: item.number })
        })
        this.getMachineList()
      }, rej => {
        this.$Message.error('生产单数据获取失败')
      })
    },
    // 获取工艺单模板
    getTemplete () {
      this.templete = []
      var params = { page: 1, size: 99 }
      api.getTemplete(params).then(res => {
        this.templeteList = res.data.content
        var data = []
        res.data.content.forEach(item => {
          data.push({ label: item.number, value: item.number })
        })
        data.push({ label: '新增模板', value: 'add' }, { label: '删除模板', value: 'delete' })
        this.templete = data
      }, rej => {
        this.$Message.error('工艺单模板获取失败')
      })
    },
    // 获取机台列表
    getMachineList () {
      var data = { page: 1, size: 99 }
      api.getMachineList(data).then(res => {
        const selected = []
        this.productTask.productOrderItems.forEach(item => {
          res.data.content.forEach(i => {
            i.outputQuantity = 0
            i.doorWidth = 0
            if (item.machine.number === i.number) {
              selected.push(i)
              i.outputQuantity = item.outputQuantity
              i.doorWidth = item.doorWidth
              i.widthCloth = item.widthCloth
              i.speed = item.speed
              i.dropMeter = item.dropMeter
            }
          })
        })
        this.machineList = res.data.content
        // 自动勾选已选的机台
        selected.forEach(item => {
          this.$refs.multipleTable.$children[0].toggleRowSelection(item)
        })
      }, rej => {
        this.$Message.error('机台列表获取失败')
      })
    },

    // 提交
    onSubmit () {
      var sum = 0
      this.productTask.productOrderItems = []
      this.productOrderItems.forEach(item => {
        var pd = false
        this.hadMachine.forEach(it => {
          if (it.id === item.id) {
            this.productTask.productOrderItems.push({
              machine: item,
              outputQuantity: item.outputQuantity * 100,
              doorWidth: item.doorWidth,
              id: item.id,
              number: it.number
            })
            pd = true
          }
        })
        if (pd === false) {
          this.productTask.productOrderItems.push({
            machine: item,
            outputQuantity: item.outputQuantity * 100,
            doorWidth: item.doorWidth,
            id: null
          })
        }
        this.productTask.productOrderItems.push({ machine: item, outputQuantity: item.outputQuantity * 100, doorWidth: item.doorWidth, widthCloth: item.widthCloth, speed: item.speed, dropMeter: item.dropMeter * 100 })
        sum += item.outputQuantity
      })
      delete this.productTask.user.team
      if (sum !== Number(this.productTask.outputQuantityTotal)) {
        this.$Message.error('机台生产米数填写错误')
        return
      }
      this.productTask.outputQuantitwyTotal *= 100
      this.productTask.dropMeter *= 100
      const data = this.productTask
      api.onSubmitupdata(data).then(res => {
        this.$Message.success('修改成功')
        this.$router.push('/process/productOrderList')
      }, rej => {
        this.productTask.outputQuantityTotal /= 100
        this.productTask.dropMeter /= 100
        this.$Message.error('修改失败')
      })
      api.onSubmitsave(data).then(res => {
        if (this.addTemplete === true) {
          this.$request({
            url: '/Template/save',
            method: 'POST',
            data: this.temple
          }).then(temRes => {
            this.$Message.success(`模板 ${this.temple.number} 保存成功`)
          }, rej => {
            this.$Message.error('模板保存失败')
          })
        }
      })
    },
    // 选择框选择事件
    selectd (data) {
      if (data === 'add') {
        this.addDialog = true
        this.productTask.product = this.temple.number
        this.addTemplete = true
      } else if (data === 'delete') {
        this.addTemplete = false
        this.deleteDialog = true
        this.productTask.product = ''
      } else {
        this.templeteList.forEach(item => {
          if (item.number === data) {
            this.temple = item
            if (item.processSheets !== null) Vue.set(this.temple, 'processSheets', item.processSheets)
          }
        })
      }
    },
    deleteSubmit () {
      this.deleteTemples.forEach(item => {
        const id = item.id
        api.deleteSubmit(id).then(res => {
          this.$Message.success(`模板${item.number}删除成功`)
          this.deleteDialog = false
          this.getTemplete()
          this.fetchData()
        }, rej => {
          this.$Message.error(`模板${item.number}删除失败`)
        })
      })
    },
    // 修改日期
    getDateArray() {
      console.log(this.productTask.createTime)
    },
    cancel () {
      this.$router.push('/process/productOrderList')
    }
  },
  mounted () {
    this.fetchData()
    this.getTemplete()
  },

  watch: {
    // 机台生产米数监听&自动取最大值
    machineList: {
      handler (newVal, oldVal) {
        var sum = 0
        var max = Number(this.productTask.outputQuantityTotal)
        newVal.forEach(item => {
          if (item.outputQuantity > max - sum) {
            if (max - sum < 0) item.outputQuantity = 0
            else item.outputQuantity = max - sum
          }
          item.outputQuantity = Number(item.outputQuantity)
          sum += item.outputQuantity
        })
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.transfer-out-or-in-container {
  width: 100%;
  color: #707070ff;
  font-size: 16px;
}

.process-info {
  padding: 18px 0;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
}

.buttom {
  height: 72px;
  margin-top: 25px;
  box-shadow: 0 0 12px rgba(235, 238, 245, 1);
}
#add{
  font-size: 20.8px;
  cursor: pointer;
}
#remove{
  font-size: 19.5px;
  cursor: pointer;
}
.ii {
  margin-left: 8px;
  font-size: 12px;
}
</style>
